export default {"src":"/_next/static/media/logo-white-with-text.7f1356d1.svg","height":39,"width":198,"blurWidth":0,"blurHeight":0};